import { VolatilityAlert } from '../../types/entities';

export interface VolatilityAlertState {
  loading: boolean;
  loaded: boolean;
  pending: boolean;
  error?: string | undefined;
  alerts: VolatilityAlert[];
}

export const initialState: VolatilityAlertState = {
  loading: false,
  loaded: false,
  pending: false,
  alerts: []
};
